import { MutationTree } from 'vuex'
import { ComponentsState } from "./componentsState"

const state: ComponentsState = {
    sidebarIsOpened: false,
};

const mutations: MutationTree<ComponentsState> = {
    handleResize(state) {
        if (document?.activeElement?.hasAttribute('insideSidebar')) {
            return;
        }
        state.sidebarIsOpened = (window.innerWidth > 1023);
    },
    setSidebar(state, isOpened) {
        state.sidebarIsOpened = isOpened
    },
}

export default {
    namespaced: true,
    state,
    mutations
}